import ShowFilesModal from './ShowFilesModal';

export default ShowFilesModal;
